import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Avatar, Text } from '../../atoms';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const AvatarName = ({ username, src, size }) => {
  const fontSize = size === 'base' ? 'sm' : 'base';
  const margin = {
    marginLeft: size === 'base' ? theme.spacing.xs : theme.spacing.s,
  };

  return (
    <Wrapper>
      <Avatar
        lazy
        src={src}
        size={size}
        shape="circle"
        mode="contain"
        alt={username}
      />
      <Text size={fontSize} style={{ ...margin }}>
        {username}
      </Text>
    </Wrapper>
  );
};

AvatarName.defaultProps = {
  size: 'base',
};

AvatarName.propTypes = {
  username: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['base', 'md']),
};

export default AvatarName;
